module.exports = __webpack_public_path__ + "static/img/cop_sch_logo2.d245136d.png";